// Form state types for host management

// Form data interface
export interface HostFormData {
    id: number;
    name: string;
    hostAddress: string;
    type: string;
    agentId: number;
    debug: boolean;
    port: number;
    username: string;
    password: string;
    passwordChanged: boolean;
    keyfile: string;
    region: string;
    filter: string;
    monitor: boolean;
    mappedInstances: number[];
    monitoringInterval: number;
    encrypted: boolean;
}

// Form validation state
export interface HostFormValidation {
    name: {
        isValid: boolean;
        isUsed: boolean;
        className: string;
    };
    hostAddress: {
        isValid: boolean;
        isUsed: boolean;
        className: string;
    };
    type: {
        isValid: boolean;
        className: string;
    };
    agentId: {
        isValid: boolean;
        className: string;
    };
    port: {
        isValid: boolean;
        className: string;
    };
    username: {
        className: string;
    };
    password: {
        className: string;
    };
    keyfile: {
        className: string;
    };
    region: {
        className: string;
    };
    isFormValid: boolean;
}

// Form UI state
export interface HostFormUIState {
    isMissing: boolean;
    disabled: boolean;
    loading: boolean;
}

// Form dependencies data
export interface HostFormDependencies {
    agents: any[];
    defaultValues: any[];
}

// Complete form state
export interface HostFormState {
    formData: HostFormData;
    validation: HostFormValidation;
    uiState: HostFormUIState;
    dependencies: HostFormDependencies;
}

// Default values
export const createDefaultFormData = (): HostFormData => ({
    id: 0,
    name: '',
    hostAddress: '',
    type: '',
    agentId: 1,
    debug: false,
    port: 22,
    username: '',
    password: '',
    passwordChanged: false,
    keyfile: '',
    region: '',
    filter: '',
    monitor: false,
    mappedInstances: [],
    monitoringInterval: 1000,
    encrypted: false
});

export const createDefaultValidation = (): HostFormValidation => ({
    name: {
        isValid: true,
        isUsed: false,
        className: ''
    },
    hostAddress: {
        isValid: true,
        isUsed: false,
        className: ''
    },
    type: {
        isValid: true,
        className: ''
    },
    agentId: {
        isValid: true,
        className: ''
    },
    port: {
        isValid: true,
        className: ''
    },
    username: {
        className: ''
    },
    password: {
        className: ''
    },
    keyfile: {
        className: ''
    },
    region: {
        className: ''
    },
    isFormValid: true
});

export const createDefaultUIState = (disabled: boolean = false): HostFormUIState => ({
    isMissing: false,
    disabled,
    loading: false
});

export const createDefaultDependencies = (): HostFormDependencies => ({
    agents: [],
    defaultValues: []
});

